const Footer = () => (
    <footer className="footer">
        <p>© {new Date().getFullYear()} Zubai Design. All rights reserved.</p>
    </footer>
);

export default Footer;
